import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createBalanceReportSlice = (set, get) => ({
    balanceReport: {
        loading: false,
        filter: {},
        data: []
    },
    getBalanceReport: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ balanceReport: { ...state.balanceReport, loading: true, filter: { ...state.balanceReport.filter, ...params } } }));
        try {
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: `v1/business/balance-report/${param.fromDate}/${param.toDate}`,
                headers: { token },
            });
            set(state => ({ balanceReport: { ...state.balanceReport, loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ balanceReport: { ...state.balanceReport, loading: false } }));
        }
    }
});
